/*
 * Subscribe & Save -> add-to-cart wiring.
 *
 * The purchase-option radios (name="salka_purchase") are rendered by the
 * "subscribe_save" Custom Liquid block, which sits ABOVE the buy buttons in
 * the product template. The hidden selling_plan field lives inside the real
 * add-to-cart form, rendered by snippets/buy-buttons.liquid.
 *
 * Two rules this file exists to enforce:
 *
 *   1. Resolve the form as form[data-type="add-to-cart-form"] and nothing else.
 *      Dawn also renders a Shop Pay installment form that posts to /cart/add,
 *      has no submit button, and appears EARLIER in the DOM. A selector like
 *      form[action*="/cart/add"] matches that one, so the plan gets written to
 *      a form that is never submitted and the customer is charged full price.
 *
 *   2. Never cache the form or the field. The section re-renders on variant
 *      change and quick-add injects its own copy, so both are looked up fresh
 *      every time.
 */
(function () {
  'use strict';

  var RADIO = 'input[name="salka_purchase"]';
  var FORM = 'form[data-type="add-to-cart-form"]';
  var FIELD = 'input[name="selling_plan"]';

  // Keep a subscription widget matched to the form it belongs to, so an open
  // quick-add modal can never write its plan into the main product form.
  function scopeOf(el) {
    return el.closest('product-info') || el.closest('quick-add-modal') || document;
  }

  function fieldFor(form) {
    if (!form) return null;
    var field = form.querySelector(FIELD);
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'selling_plan';
      form.appendChild(field);
    }
    return field;
  }

  function sync(scope) {
    var form = scope.querySelector ? scope.querySelector(FORM) : null;
    if (!form) return;

    var field = fieldFor(form);
    if (!field) return;

    var checked = scope.querySelector(RADIO + ':checked');
    field.value = checked ? checked.value || '' : '';
    // A disabled input is omitted from FormData, so a one-time purchase sends
    // no selling_plan key at all rather than an empty one.
    field.disabled = !field.value;
  }

  function paint(box, target) {
    var opts = box.querySelectorAll('.salka-sub__opt');
    for (var i = 0; i < opts.length; i++) {
      opts[i].classList.toggle('is-selected', opts[i].contains(target));
    }
  }

  document.addEventListener('change', function (event) {
    var radio = event.target;
    if (!radio || radio.name !== 'salka_purchase') return;

    var scope = scopeOf(radio);
    sync(scope);

    var box = radio.closest('.salka-sub');
    if (box) paint(box, radio);
  });

  // Last line of defence. Runs in capture phase, so it fires before Dawn's
  // <product-form> handler reads FormData off the form.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches(FORM)) return;
      sync(scopeOf(form));
    },
    true
  );

  // Cover a section re-render that rebuilds the form with an empty field.
  document.addEventListener('DOMContentLoaded', function () {
    var boxes = document.querySelectorAll('.salka-sub');
    for (var i = 0; i < boxes.length; i++) sync(scopeOf(boxes[i]));
  });
})();
